import React from "react";
import { closeMobileSidebar } from "../../utils/sidebarState";

export default function SidebarCloseButton() {
  const handleClose = (event) => {
    event.preventDefault();
    closeMobileSidebar();
  };

  return (
    <div className="sidebar-close">
      <button
        type="button"
        className="sidebar-close__btn"
        onClick={handleClose}
        aria-label="Close menu"
      >
        <i className="ti-close" aria-hidden="true" />
      </button>
    </div>
  );
}
